import { Check } from '@ethsign/icons';
import classNames from 'classnames';

export const StepTab = ({ items, current }: { items: any; current: number }) => {
  return (
    <div className="flex items-center justify-between h-[60px]">
      {items.map((item: any, index: number) => {
        return (
          <div
            key={index}
            className={classNames('border-b-[2px] px-[24px] py-[8px] gap-[8px] h-full flex items-center', {
              'border-primary-700': index === current,
              'border-transparent': index !== current
            })}
          >
            <div
              className={classNames(
                'w-[24px] h-[24px] rounded-full bg-gray-100 flex items-center justify-center text-xs font-medium',
                {
                  'text-primary-700 bg-primary-100': index === current,
                  'bg-slime-50': current > index
                }
              )}
            >
              {current > index ? <Check color={'#12B76A'} size={18} /> : index + 1}
            </div>
            <div
              className={classNames('text-md font-medium text-gray-500', {
                'text-primary-700': index === current
              })}
            >
              {item.title}
            </div>
          </div>
        );
      })}
    </div>
  );
};
